const TimestampDisplay = ({ label, timestamp }) => {
  // Check if timestamp exists before trying to format it
  const formatted = timestamp
    ? new Date(timestamp).toLocaleString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
        timeZone: "UTC", // Explicitly use UTC to match the server time
      })
    : "Not verified";

  return (
    <div className="mt-4 w-full max-w-xs z-0">
      <label className="text-white capitalize block mb-1">{label}</label>
      <div className="bg-gray-800 text-white rounded-lg px-4 py-3 shadow-sm text-sm">
        {formatted}
      </div>
    </div>
  );
};

export default TimestampDisplay;
